import store from '@/common/store'
import { api_get, stringfy_post } from '../utils/http'
import { LONG_DAYS, URLS, USER_GROUPS, USER_NAME } from './constant'

// 设置cookie
function setCookie(cname: string, cvalue: string, exdays: number) {
  let d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + '; ' + expires
}
// 获取cookie
function getCookie(cname: string) {
  const trim = (item) => (item || '').trim()
  let kvs = document.cookie.split(';').map((item) => item.trim())
  for (let kv of kvs) {
    const [k, v] = kv.split('=')
    if (cname == trim(k)) {
      return trim(v)
    }
  }
  return ''
}
// 清除cookie
function clearCookie(name: string) {
  setCookie(name, '', -1)
}

function saveUserGroups(groups: string[]) {
  setCookie(USER_GROUPS, JSON.stringify(groups || []), LONG_DAYS)
}

function getUserGroups(): string[] {
  let str = getCookie(USER_GROUPS)
  try {
    return JSON.parse(str) || []
  } catch (err) {
    return []
  }
}

function saveUserName(name: string) {
  setCookie(USER_NAME, name, LONG_DAYS)
}

function getUserName() {
  return getCookie(USER_NAME)
}

function clearAuthInfo() {
  clearCookie(USER_NAME)
  clearCookie(USER_GROUPS)
}

function login(data: { back_url: string; ticket: string }) {
  return stringfy_post(URLS.OSS_LOGIN, data)
}

function logout() {
  return api_get(URLS.LOGOUT, {})
}

function getSsoUrl() {
  return 'https://sso.oaloft.com/cas/logout?service=' + decodeURI(getHomeUrl())
}

function logoutAction(notJump?: boolean) {
  store.commit('clearAuthInfo')
  clearAuthInfo()
  if (!notJump) {
    location.href = getSsoUrl()
  }
}

function getHomeUrl() {
  return location.protocol + '//' + location.host + '/csearch/'
}
export {
  saveUserName,
  getUserName,
  saveUserGroups,
  getUserGroups,
  login,
  logout,
  getSsoUrl,
  logoutAction,
  getHomeUrl
}
